import { convertCRMDate, convertToCRMDate } from "../../helper";
import { LineItems, PendingContractState } from "./types";

export const mapApiPendingContract = (payload: any): PendingContractState => {
  return {
    id: payload["id"],
    purchaseDate: convertCRMDate(payload["contract_purchase_date"]),
    customerAddress: `${payload["customer_street_address_1"] || ""} ${
      payload["customer_street_address_2"] || ""
    }`.trim(),
    storeName: payload["selling_store_location"] || "",
    salesPerson: payload["sales_person_id"] || "",
    documents: [],
    invoiceImg: payload["invoice_img"] || "",
    invoiceNumber: payload["invoice_number"] || "",
    contractPurchaseDate: convertCRMDate(payload["contract_purchase_date"]),
    customerFirstName: payload["customer_first_name"] || "",
    customerLastName: payload["customer_last_name"] || "",
    recordType: payload["record_type"] || "",
    sellingStoreLocation: payload["selling_store_location"] || "",
    sellingStoreAddress: payload["selling_store_address"] || "",
    sellingStoreCity: payload["selling_store_city"] || "",
    sellingStoreState: payload["selling_store_state"] || "",
    sellingStorePostalCode: payload["selling_store_postal_code"] || "",
    sellingStoreCountryCode: payload["selling_store_country_code"] || "",
    salesPersonId: payload["sales_person_id"] || "",
    customerId: payload["customer_id"] || "",
    customerStreetAddress1: payload["customer_street_address_1"] || "",
    customerStreetAddress2: payload["customer_street_address_2"] || "",
    customerCity: payload["customer_city"] || "",
    customerState: payload["customer_state"] || "",
    customerPostalCode: payload["customer_postal_code"] || "",
    customerCountryCode: payload["customer_country_code"] || "",
    customerEmail: payload["customer_email"] || "",
    customerPrimaryTelephone: payload["customer_primary_telephone"] || "",
    customerAlternativeTelephone:
      payload["customer_alternative_telephone"] || "",
    customerDeliveryStreetAddress1:
      payload["customer_delivery_street_address_1"] || "",
    customerDeliveryStreetAddress2:
      payload["customer_delivery_street_address_2"] || "",
    customerDeliveryCity: payload["customer_delivery_city"] || "",
    customerDeliveryState: payload["customer_delivery_state"] || "",
    customerDeliveryPostalCode: payload["customer_delivery_postal_code"] || "",
    customerDeliveryCountryCode:
      payload["customer_delivery_country_code"] || "",
    contractRetailPrice: +payload["contract_retail_price"] || 0,
    totalProductRetailValue: +payload["total_product_retail_value"] || 0,
    originalTransactionId: payload["original_transaction_id"] || "",
    originalDealerStoreId: payload["original_dealer_store_id"] || "",
    originalContractPurchaseDate: convertCRMDate(
      payload["original_contract_purchase_date"]
    ),
    protectallSku: payload["protectall_sku"] || "",
    lineItems: payload["lineItems"]
      ? payload["lineItems"].map(mapApiLineItems)
      : [],
  };
};

const mapApiLineItems = (item: any = {}): LineItems => ({
  id: item.id || "",
  manufacturer: item.manufacturer || "",
  modelNumber: item.model_number || "",
  serialNumber: item.serial_number || "",
  purchaseDateOfProduct: convertCRMDate(item.purchase_date_of_product),
  deliveryDateOfProduct: convertCRMDate(item.delivery_date_of_product),
  productRetailPrice: +item.product_retail_price || 0,
  quantity: +item.quantity || 0,
  productSku: item.product_sku || "",
  productDescription: item.product_description || "",
  productQuality: item.product_quality || "",
});

export const mapFormValuesToContract = (payload: any): any => {
  payload.line_items ||= [];
  return {
    dealer_id: payload.dealer_id?.value || payload.dealer_id,
    invoice_number: payload.invoice_number || "",
    protectall_sku: payload.protectall_sku?.value || "",
    record_type: "S",
    contract_retail_price: payload.contract_retail_price || "",
    total_product_retail_value: payload.total_product_retail_value || "",
    customer_id: payload.customer_id || "",
    customer_first_name: payload.first_name || "",
    customer_last_name: payload.last_name || "",
    customer_email: payload.email || "",
    customer_primary_telephone: payload.customer_primary_telephone || "",
    customer_alternative_telephone:
      payload.customer_alternative_telephone || "",
    customer_street_address_1: payload.customerAddress?.address || "",
    customer_street_address_2: payload.customerAddress?.address_2 || "",
    customer_city: payload.customerAddress?.city || "",
    customer_state: payload.customerAddress?.state || "",
    customer_postal_code: payload.customerAddress?.zip_code || "",
    customer_country_code: payload.customerAddress?.country_code,
    customer_delivery_street_address_1: payload.deliveryAddress?.address || "",
    customer_delivery_street_address_2:
      payload.deliveryAddress?.address_2 || "",
    customer_delivery_city: payload.deliveryAddress?.city || "",
    customer_delivery_state: payload.deliveryAddress?.state || "",
    customer_delivery_postal_code: payload.deliveryAddress?.zip_code || "",
    customer_delivery_country_code: payload.deliveryAddress?.country_code || "",
    selling_store_code: payload.selling_store_code || "",
    selling_store_location: payload.selling_store_location || "",
    selling_store_address: payload.sellingStoreAddress?.address || "",
    selling_store_city: payload.sellingStoreAddress?.city || "",
    selling_store_state: payload.sellingStoreAddress?.state || "",
    selling_store_postal_code: payload.sellingStoreAddress?.zip_code || "",
    selling_store_country_code: payload.sellingStoreAddress?.country_code,
    contract_purchase_date:
      convertToCRMDate(payload.contract_purchase_date) || "",
    delivery_date:
      convertToCRMDate(
        payload.delivery_date || payload.line_items[0].delivery_date_of_product
      ) || "",
    sales_person_id: payload.sales_person_id || "",
    reference_number: payload.reference_number || "",
    product_line_items: payload.line_items.map((item: any, index: number) =>
      mapProductLineItems(item, index, payload.invoice_number)
    ),
  };
};

export const mapProductLineItems = (
  item: any = {},
  index: number = 0,
  invoiceNumber: string = ""
) => ({
  manufacturer: item.manufacturer || "",
  model_number: item.model_number || "",
  serial_number: item.serial_number || "",
  purchase_date_of_product:
    convertToCRMDate(item.purchase_date_of_product) || "",
  delivery_date_of_product:
    convertToCRMDate(item.delivery_date_of_product) || "",
  product_retail_price: item.product_retail_price || "",
  quantity: item.quantity || "",
  sequence_number: item.sequence_number
    ? String(item.sequence_number)
    : invoiceNumber
      ? `${invoiceNumber}_${index + 1}`
      : String(index + 1),
  product_quality: item.product_quality?.value || "",
  product_sku: item.product_sku || "",
  product_description: item.product_description || "",
});
